import { createContext, useCallback, useContext, useState } from 'react'

const AppAuthContext = createContext<any>(null)

export const AppAuthProvider = ({ children }: { children: React.ReactNode }) => {
  const [authData, setAuthData] = useState<ContextType>({
    web3token: localStorage.getItem('web3token') || '',
    isSessionExpired: false,
    arcanaAcc: localStorage.getItem('arcanaAcc') || '',
    metamaskAcc: localStorage.getItem('metamaskAcc') || '',
  })

  const setIsSessionExpired = useCallback(
    () => (value: boolean) => {
      setAuthData((prev) => ({
        ...prev,
        isSessionExpired: value,
      }))
    },
    []
  )

  const setArcanaAcc = (value: string) => {
    setAuthData((prev) => ({
      ...prev,
      arcanaAcc: value,
    }))
  }

  const setMetamaskAcc = (value: string) => {
    setAuthData((prev) => ({
      ...prev,
      metamaskAcc: value,
    }))
  }

  const setWeb3Token = (value: string) => {
    setAuthData((prev) => ({
      ...prev,
      web3token: value,
    }))
  }

  return (
    <AppAuthContext.Provider value={{ authData, setArcanaAcc, setMetamaskAcc, setWeb3Token, setIsSessionExpired }}>
      {children}
    </AppAuthContext.Provider>
  )
}

export const useAuthContext = () => useContext<IUseData>(AppAuthContext)

interface IUseData {
  authData: ContextType
  setArcanaAcc: (value: string) => void
  setMetamaskAcc: (value: string) => void
  setWeb3Token: (value: string) => void
  setIsSessionExpired: (value: boolean) => void
}

type ContextType = {
  isSessionExpired: boolean
  web3token: string
  arcanaAcc: string
  metamaskAcc: string
}
